
import React, { createContext, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';

const SportContext = createContext();
export const useSport = () => useContext(SportContext);

export const sportTypes = {
    football: { key: 'football', name: 'Football', icon: '⚽' },
    basketball: { key: 'basketball', name: 'Basketball', icon: '🏀' },
    volleyball: { key: 'volleyball', name: 'Volleyball', icon: '🏐' },
    tennis: { key: 'tennis', name: 'Tennis', icon: '🎾' },
    tabletennis: { key: 'tabletennis', name: 'Ping Pong', icon: '🏓' },
    frisbee: { key: 'frisbee', name: 'Frisbee', icon: '🥏' },
    kitesurfing: { key: 'kitesurfing', name: 'Kitesurfing', icon: '🏄‍♀️🪁' },
    music: { key: 'music', name: 'Music', icon: '🎵' }
};

export const SportProvider = ({ children }) => {
    const { user, updateUser } = useAuth();

    const selectedSportKey = user?.favorite_sport || 'football';

    const selectedSport = useMemo(() => {
        return sportTypes[selectedSportKey] || sportTypes.football;
    }, [selectedSportKey]);

    const setSelectedSportKey = (newVibe) => {
        if (updateUser) {
            updateUser({ favorite_sport: newVibe });
        }
    };
    
    const value = { selectedSport, selectedSportKey, setSelectedSportKey, sportTypes };
    
    return (
        <SportContext.Provider value={value}>
            {children}
        </SportContext.Provider>
    );
};

